import { Appearance, ProductType } from '@/types';

export const isSizeAvailable = (
  productType: ProductType,
  appearance: Appearance,
  sizeId: string
) => {
  const stockState = productType.stockStates.find(
    (s) => s.appearance.id === appearance.id && s.size.id === sizeId
  );
  return Boolean(stockState && stockState.available);
};
